import type {PermissionsRecordType} from '../permissions';

export const workshopPermissions = {
  createCatalogueItem: {
    resourceId: 'LABOUR_CATALOGUE_ITEM',
    actionId: 'CREATE',
    scopes: [],
  },
  editCatalogueItem: {
    resourceId: 'LABOUR_CATALOGUE_ITEM',
    actionId: 'EDIT',
    scopes: [],
  },
  materialDispatch: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'MATERIAL_DISPATCH',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE'],
  },
  materialNonBinding: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'MATERIAL_NON_BINDING',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE'],
  },
  materialRequest: {
    resourceId: 'SERVICE_ITEM',
    actionId: 'MATERIAL_REQUEST',
    scopes: ['BRANCH', 'SERVICE_CASE_TYPE', 'SERVICE_ORDER_TYPE'],
  },
  allowBankTransfer: {
    resourceId: 'CUSTOMER',
    actionId: 'ALLOW_BANK_TRANSFER',
    scopes: [],
  },
  createCustomerOrder: {
    resourceId: 'CUSTOMER',
    actionId: 'CREATE_CUSTOMER_ORDER',
    scopes: [],
  },
} satisfies PermissionsRecordType;
